/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'timeline-exit': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" _fill="none" fill-rule="evenodd"><path pid="0" d="M6.604 19.07c3.585-.583 7.219-.357 8.364-.021l7.223 2.12c2.06.604 1.148 3.731-.912 3.126l-7.588-2.227"/><path pid="1" d="M23.223 22.315l5.628-2.786c2.042-1.01 3.327 2.239 1.394 3.195l-7.643 3.783c-1.306.646-6.495 1.116-12.254-1.68-.99-.48-2.671.144-3.744.443M1 18h5v10H1z"/><circle pid="2" cx="20" cy="10" r="7"/><path pid="3" d="M18.262 11.977c.484.428 1.23.75 1.768.75.862 0 1.56-.621 1.56-1.387s-.745-1.144-1.56-1.386c-.844-.27-1.56-.621-1.56-1.387 0-.765.699-1.386 1.56-1.386.58 0 1.087.281 1.356.699M20.027 6.5v.512M20.027 13.028v.472"/></g>'
  }
})
